import { Button, Modal, notification } from "antd";
import React, { useState } from "react";
import { downloadFile, genViewTemplate } from "./view-template";

export default function View({ open, onClose, value }) {
  const [loading, setLoading] = useState(false);
  if (!value || typeof value !== "object") return <p>No data</p>;

  const bodyTemplate = genViewTemplate(value);
  return (
    <Modal
      open={open}
      onCancel={onClose}
      title="Phiếu Lương"
      width={"800px"}
      footer={null}
    >
      <div dangerouslySetInnerHTML={{ __html: bodyTemplate }}></div>
      <Button
        onClick={async () => {
          setLoading(true);
          try {
            await downloadFile(
              bodyTemplate,
              [value?.hoTen, value?.email].filter(Boolean).join(" - "),
            );
            notification.success({ message: "Tải phiếu lương thành công" });
          } catch (err) {
            notification.error({ message: err?.toString() });
          }
          setLoading(false);
        }}
        type="primary"
        loading={loading}
      >
        Tải phiếu lương
      </Button>
    </Modal>
  );
}
